import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Button, Box, Typography, IconButton, Chip, TextField, InputAdornment, Dialog, DialogTitle, DialogContent, Switch, FormControlLabel, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { UserContext } from '../assets/contexts/userContext';
import PageTitle from '../components/PageTitle';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import DashboardNavbar from '../components/dashboard/DashboardNavbar';
import ComplexStatisticsCard from '../components/dashboard/ComplexStatisticsCard';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import TableRowsIcon from '@mui/icons-material/TableRows';
import EmployeeStats from './EmployeeStats';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import * as utils from '../assets/js/utils';
import * as endPoints from '../assets/js/endpoints';
import Paper from '@mui/material/Paper';
import { useNotification } from '../assets/contexts/notificationContext';
import { Helmet } from 'react-helmet';

function EmployeeDashboard() {
  const navigate = useNavigate();
 const { user } = useContext(UserContext);
 const [appointments, setAppointments] = useState([]);
  const { showNotification } = useNotification();


  useEffect(() => {
    const loadAppointments = async () => {
      try {
        const data = await endPoints.getAppointmentsByRole(user.role, user.id);
        const now = new Date();
        const limit = 15 * 24 * 60 * 60 * 1000; // 15 días
        const upcoming = (Array.isArray(data) ? data : [])
          .filter(a => {
            const dt = new Date(`${a.date}T${a.time || '00:00'}`);
            return dt > now && dt - now <= limit;
          })
          .sort(
            (a, b) =>
              new Date(`${a.date}T${a.time || '00:00'}`) -
              new Date(`${b.date}T${b.time || '00:00'}`)
          );
        setAppointments(upcoming);
      } catch (_err) {
        showNotification('Error cargando citas', 'error');
      }
    };
    if (user.id !== null) loadAppointments();
  }, [user.id, user.role]);

  return (
    <>
      <Helmet>
        <title>Panel de Empleado | CES</title>
      </Helmet>
      <DashboardLayout>
      {/* <DashboardNavbar title="Empleado" /> */}
      <Box py={1}>
        <PageTitle>Bienvenid@ {`${user.name} ${user.lastName ?? ''}`}</PageTitle>
        <Grid container spacing={3} mt={4} justifyContent={'justify'}>
          <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard icon={<CalendarMonthRoundedIcon/>} title="Mis Citas" color="primary"  onClick={() => navigate('/employee/citas')}>
              {/* <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/employee/citas')}>
                Ver Citas
              </Button> */}
            </ComplexStatisticsCard>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard icon={<ArticleRoundedIcon/>} title="Mis formularios" color="primary" onClick={() => navigate('/employee/forms')}>
              {/* <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/employee/forms')}>
                Ver Formularios
              </Button> */}
            </ComplexStatisticsCard>
          </Grid>
            <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard icon={<ArticleRoundedIcon/>} title="Mis artículos" color="primary" onClick={() => navigate('/employee/articles')}>
            {/* <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/employee/articles')}>
                Ver Artículos
              </Button>  */}
            </ComplexStatisticsCard>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard icon={<PeopleAltRoundedIcon/>} title="Mis Clientes" color="primary" onClick={() => navigate('/employee/clientes')}>
              {/* <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/employee/clientes')}>
                Ver Clientes
              </Button> */}
            </ComplexStatisticsCard>
          </Grid>  
           <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard icon={<ArticleRoundedIcon/>} title="Mis informes" color="primary" onClick={() => navigate('/employee/reports')}>
            {/* <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/employee/reports')}>
                Ver Informes
              </Button>  */}
            </ComplexStatisticsCard>
          </Grid>
          
        </Grid>
       <Paper elevation={3} sx={{ p:3, mt:3 }}>
        <Grid item xs={12} md={6} lg={4}>
            <Typography sx={{fontWeight:700}} gutterBottom>
              Próximas citas (15 días)
            </Typography>
            {appointments.length > 0 ? (
              <TableContainer>
                <Table size="small" sx={{ '& td, & th': { borderColor: '#D4D4D4' } }}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{fontWeight:700}}>Cliente</TableCell>
                      <TableCell sx={{fontWeight:700}}>Servicio</TableCell>
                      <TableCell sx={{fontWeight:700}}>Fecha</TableCell>
                      <TableCell sx={{fontWeight:700}}>Hora</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {appointments.map(a => (
                      <TableRow key={a.id}>
                        <TableCell sx={{ minWidth: 160 }}>
                          {(a.client_name && a.client_name !== 'null') ? a.client_name : 'Sin cliente'}{' '}
                          {(a.client?.apellidos && a.client.apellidos !== 'null') ? a.client.apellidos : ''}
                        </TableCell>
                        <TableCell>{a.service_name || a.service?.name}</TableCell>
                        <TableCell>{a.date}</TableCell>
                        <TableCell>{(a.time || '').substring(0,5)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography>Aún no hay citas concertadas</Typography>
            )}
          </Grid>
           </Paper>
        <EmployeeStats />
      </Box>
      </DashboardLayout>
    </>
  );
}

export default EmployeeDashboard;
